import React, { useEffect, useState } from "react";
import ic_cubix_ribbon_logo from "../img/ic_cubix_ribbon_label.png";
import "../css/LoginPage.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import LoadingUI from "./LoadingUI";
import bottom_car_patch from "../img/gii.png";
import cwheels_logo from "../img/cwheels_logo.jpg";

function LoginPage() {

    const [isCallingAPI, setIsCallingApi] = useState(false);

    const navigate = useNavigate();

    const initialLoginField = {
        username: "",
        password: ""
    }
    const initialInputErrorState = "";

    const [inputFieldState, setInputFieldState] = useState(initialLoginField);

    const [inputErrorState, setInputErrorState] = useState(initialInputErrorState);

    const clickedOnLogin = () => {
        console.log("inputFieldState is ", inputFieldState);

        if (inputFieldState.username.length > 0 && inputFieldState.password.length > 0) {
            callLoginAPI();
        } else {
            setInputErrorState("Please enter input field");
        }
    }

    const handleInput = (e) => {
        setInputErrorState(initialInputErrorState);
        setInputFieldState({ ...inputFieldState, [e.target.name]: e.target.value })
    }

    const callLoginAPI = () => {

        setIsCallingApi(true);
        setInputErrorState("");

        axios.get(`${process.env.REACT_APP_BACK_END_BASE_URL}/loginuser/${inputFieldState.username}/${inputFieldState.password}`).then(
            (res) => {


                console.log("res.data.jsont.Column1", res);
                setIsCallingApi(false)

                if (res.data.jsont[0].Column1 == "true") {

                    localStorage.setItem("cwheels_user_isAuthenticated", true);
                    
                    navigate("/home", { replace: true })
                } else {
                    setInputErrorState("please enter correct username and password");
                }
            }
        ).catch((err) => {
            setIsCallingApi(false)
            setInputErrorState("Something went wrong , please try again");
        })
    }


    return (
        <div className="LoginPage-root-container">

            <div className="LoginPage-layer-2 ">

                {/* <img src={bottom_car_patch} className="LoginPage-bottom-patch-image" /> */}

                <div className="LoginPage-main-central-div">
                    <img src={cwheels_logo} className="LoginPage-logo-class mt-4" />
                    {/* <h2 className="text-center LoginPage-Company-name">CWheels</h2> */}
                    <div className="LoginPage-inner-card ">
                        <input className="mt-2" placeholder="Username" type="text" name="username" value={inputFieldState.username} onChange={(e) => handleInput(e)} />
                        <input className="mt-2" placeholder="Password" type="password" name="password" value={inputFieldState.password} onChange={(e) => handleInput(e)} />

                        {inputErrorState.length > 0 ?
                            <div className="text-danger text-center mt-3">
                                <label>{inputErrorState}</label>
                            </div>
                            :
                            null
                        }


                        {
                            isCallingAPI ?
                                <div className="my-4">
                                    <div class="spinner-border" role="status">

                                    </div>

                                </div> :

                                <button className="LoginPage-log-in-button" onClick={() => clickedOnLogin()}>Log in</button>
                        }

                    </div>

                    <div className="LoginPage-cubix_logo_container">
                        <label>powered by </label>
                        <a href="https://cubixitsolutions.com/" className="ms-2">
                            <img src={ic_cubix_ribbon_logo} className="LoginPage-cubix-logo" />
                        </a>
                    </div>

                </div>

            </div>

        </div>
    )

}

export default LoginPage;